export default __webpack_public_path__ + "static/great_expectations-0d7accafc812b2b44f38030221f3592e.png";